export enum RichTextMenuButtonType {
  IncreaseFontSize = 'IncreaseFontSize',
  DecreaseFontSize = 'DecreaseFontSize',
  Bold = 'Bold',
  Italic = 'Italic',
  Underline = 'Underline',
  StrikeThrough = 'StrikeThrough',
  Subscript = 'Subscript',
  Superscript = 'Superscript',
  UnorderedList = 'UnorderedList',
  OrderedList = 'OrderedList',
  Indent = 'Indent',
  Outdent = 'Outdent',
  AlignLeft = 'AlignLeft',
  AlignCenter = 'AlignCenter',
  AlignRight = 'AlignRight',
  AlignJustify = 'AlignJustify',
  ClearFormatting = 'ClearFormatting',
}
